export default __webpack_public_path__ + "static/media/donation.9baf6adf.svg";